import PropTypes from 'prop-types';
import React from 'react';
export const OrganisationsFilterContext = React.createContext({
    selectedOrganisations: [],
});
export const organisationsFilterContextPropTypes = {
    selectedOrganisations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    })),
    organisationsSubtree: PropTypes.any,
    setSelectedOrganisations: PropTypes.func.isRequired,
};
export default class OrganisationsFilterContextProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            selectedOrganisations: [],
            organisationsSubtree: null,
        };
        this.setSelectedOrganisations = (selectedOrganisations, organisationsSubtree) => {
            this.setState({
                selectedOrganisations,
                organisationsSubtree,
            });
        };
    }
    render() {
        const { selectedOrganisations, organisationsSubtree } = this.state;
        const { children } = this.props;
        return (<OrganisationsFilterContext.Provider value={{
            selectedOrganisations,
            organisationsSubtree,
            setSelectedOrganisations: this.setSelectedOrganisations,
        }}>
        {children}
      </OrganisationsFilterContext.Provider>);
    }
}
OrganisationsFilterContextProvider.propTypes = {
    children: PropTypes.node,
};
OrganisationsFilterContextProvider.defaultProps = {
    children: null,
};
